import { render, staticRenderFns } from "./special_price_edit.vue?vue&type=template&id=3b4177cc&"
import script from "./special_price_edit.vue?vue&type=script&lang=js&"
export * from "./special_price_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports